<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sHdwML/tc-custom/9781617752674.jpg?1734325154919" alt="This image is the cover for the book Don Dimaio of La Plata, Akashic Urban Surreal Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Don Dimaio of La Plata, Akashic Urban Surreal Series
      </h1>
      <p class="bookDescription body article font2">
        <b>A tale of political downfall from “an exceptional creative talent perfectly in tune with his own rapidly changing times” (Robert Coover, bestselling author of<i> The Public Burning</i>).</b><br/>  <br/> In 2002, real-life mayor of Providence, Rhode Island, Vincent “Buddy” Cianci was convicted of extortion. This is the story of Don “Pally” Dimaio, mayor of La Plata, as his corrupt administration spirals out of control.<br/>  <br/> From the award-winning author of <i>Curse the Names</i> and <i>Fast Eddie, King of the Bees</i>, this is a wildly inventive satirical novel that toggles between adaptations of the language of Cervantes and a narrative of an American mayor’s quixotic decline.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert Arellano
      </h2>
      
      <p class="authorDescription body article">Robert Arellano teaches creative writing at Brown University. He is the author of <I>Fast Eddie</I>, and his short fiction has appeared in the <I>Kenyon Review</I> and <I>Jane</I>. As an indie musician, Arellano has played with Will Oldham and Nick Cave.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
       Akashic Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bfe9152c